class BruSizeDimensions extends HTMLElement {
  connectedCallback() {
    this.output = this.querySelector('[data-size-output]');
    this.map = JSON.parse(this.querySelector('[data-size-map]')?.textContent || '{}');
    this.section = this.dataset.section;
    this.onChange = this.handleChange.bind(this);

    document.querySelectorAll(`#variant-selects-${this.section} input, #variant-selects-${this.section} select`).forEach((el) => {
      el.addEventListener('change', this.onChange);
    });

    this.handleChange();
  }

  disconnectedCallback() {
    document.querySelectorAll(`#variant-selects-${this.section} input, #variant-selects-${this.section} select`).forEach((el) => {
      el.removeEventListener('change', this.onChange);
    });
  }

  handleChange() {
    const root = document.querySelector(`#variant-selects-${this.section}`);
    if (!root || !this.output) return;

    let sizeValue = '';
    root.querySelectorAll('input[type="radio"]:checked, select').forEach((input) => {
      const name = (input.name || input.id || '').toLowerCase();
      if (name.includes('size') || input.closest('.product-form__input')?.querySelector('.form__label')?.textContent?.toLowerCase().includes('size')) {
        sizeValue = input.value || input.options?.[input.selectedIndex]?.text || '';
      }
    });

    if (!sizeValue) {
      root.querySelectorAll('.product-form__input').forEach((fieldset) => {
        const label = fieldset.querySelector('.form__label')?.textContent?.toLowerCase() || '';
        if (label.includes('size')) {
          const checked = fieldset.querySelector('input[type="radio"]:checked');
          if (checked) sizeValue = checked.value;
        }
      });
    }

    const key = sizeValue.toLowerCase().trim();
    const dims = this.map[key];
    this.output.textContent = dims ? `${sizeValue} · ${dims}` : (sizeValue ? sizeValue : 'Select a size to see dimensions.');
  }
}

if (!customElements.get('bru-size-dimensions')) {
  customElements.define('bru-size-dimensions', BruSizeDimensions);
}

function syncSizePicker(picker, input, { close = false } = {}) {
  if (!input) return;

  picker.querySelectorAll('.size-picker__option').forEach((option) => {
    option.classList.toggle('is-selected', option.contains(input));
  });

  const selectedName = picker.querySelector('[data-size-selected-name]');
  const selectedValue = picker.querySelector('[data-selected-value]');
  const selectedDimensions = picker.querySelector('[data-size-selected-dimensions]');
  const details = picker.querySelector('details');

  if (selectedName) selectedName.textContent = input.value;
  if (selectedValue) selectedValue.textContent = input.value;
  if (selectedDimensions) selectedDimensions.textContent = input.dataset.sizeDimensions || '';
  if (close && details) details.open = false;
}

function initSizeVariantPickers(root = document) {
  root.querySelectorAll('[data-size-picker]:not([data-size-picker-ready])').forEach((picker) => {
    picker.setAttribute('data-size-picker-ready', 'true');
    picker.addEventListener('change', (event) => {
      const input = event.target;
      if (!input.checked) return;
      syncSizePicker(picker, input, { close: true });
    });
    syncSizePicker(picker, picker.querySelector('.size-picker__input:checked'));
  });
}

initSizeVariantPickers();
document.addEventListener('shopify:section:load', (event) => initSizeVariantPickers(event.target));
